const Save = (props) => {
	return <div>Edit profile </div>;
};

export default Save;
